<style scoped lang="scss" type="text/scss">
    .player-application-container {
        display: flex;
        align-items: flex-start;

        .team-basic-info {
            width: 18rem;
            margin-right: 1rem;
        }

        .content-container {
            flex: 1;

            .info-panel {
                margin-bottom: 1rem;
            }
        }
    }
</style>

<template>
    <div class="player-application-container">
        <team-basic-info class="team-basic-info"></team-basic-info>
        <card class="content-container">
            <block-divider>开放报名中的赛事</block-divider>
            <registrable-competitions :data="registrableCompetitions"
                                      @need-reload="afterRegistration"
                                      :loading="registrableCompetitionRequesting"
            >
            </registrable-competitions>

            <block-divider>正在处理中的参赛申请</block-divider>
            <info-panel class="info-panel">若申请被驳回，系统会向您发送站内信通知</info-panel>
            <unfinished-player-applications :data="unfinishedPlayerApplications"
                                            :loading="unfinishedPlayerApplicationRequesting"
            >
            </unfinished-player-applications>

            <block-divider>已参加的赛事</block-divider>
            <registered-competitions :data="registeredCompetitions"
                                     :loading="registeredCompetitionRequesting">
            </registered-competitions>
        </card>
    </div>
</template>

<script>
    import Card from '../../../../../components/card';
    import BlockDivider from '../../../../../components/divider/block';
    import TeamBasicInfo from '../sub-components/team-basic-info';
    import RegistrableCompetitions from './registrable-competitions';
    import RegisteredCompetitions from './registered-competitions';
    import UnfinishedPlayerApplications from './unfinished-player-applications';
    import InfoPanel from '../../../../../components/info-panel';
    import {handleCompetitions, handlePlayerApplications} from '../../../../../utils/data-handler';
    import _ from 'lodash';

    export default {
        name: '',
        components: {
            Card,
            TeamBasicInfo,
            BlockDivider,
            RegistrableCompetitions,
            RegisteredCompetitions,
            UnfinishedPlayerApplications,
            InfoPanel
        },
        created () {
            this.loadRegistrableCompetitions();
        },
        data () {
            return {
                registeredCompetitions: [],
                unfinishedPlayerApplications: [],
                registeredCompetitionRequesting: false,
                unfinishedPlayerApplicationRequesting: false,
                registrableCompetitionRequesting: false
            };
        },
        watch: {
            currentManagedTeamId: {
                immediate: true,
                handler (id) {
                    if (id === null || id === undefined) return;
                    this.loadRegisteredCompetitions();
                    this.loadUnfinishedPlayerApplicationsByTeamId();
                }
            }
        },
        computed: {
            currentManagedTeamId () {
                return this.$store.state.team.currentManagedTeamId;
            },
            registrableCompetitions () {
                const registrableCompetitions = this.$store.state.competition.registrableCompetitions;
                const registeredCompetitionIds = _.map(this.registeredCompetitions, 'id');
                const unfinishedCompetitionIds = _.map(this.unfinishedPlayerApplications, 'competition.id');
                const handledCompetitions = handleCompetitions(registrableCompetitions);
                for (const index in handledCompetitions) {
                    const current = handledCompetitions[index];
                    this.$set(current, 'registered', false);
                    this.$set(current, 'application_unfinished', false);
                    if (registeredCompetitionIds.indexOf(current.id) > -1) {
                        current['registered'] = true;
                    }
                    if (unfinishedCompetitionIds.indexOf(current.id) > -1) {
                        current['application_unfinished'] = true;
                    }
                }
                return handledCompetitions;
            }
        },
        methods: {
            afterRegistration () {
                this.loadRegisteredCompetitions();
                this.loadUnfinishedPlayerApplicationsByTeamId();
            },
            loadRegistrableCompetitions () {
                this.$normalRequest('competition/loadRegistrableCompetitions', null, false, false, this, 'registrableCompetitionRequesting').then();
            },
            loadRegisteredCompetitions () {
                this.$normalRequest('competition/loadRegisteredCompetitions', {
                    team_id: this.currentManagedTeamId
                }, false, false, this, 'registeredCompetitionRequesting').then(data => {
                    this.registeredCompetitions = handleCompetitions(data);
                }).catch(_ => {
                });
            },
            loadUnfinishedPlayerApplicationsByTeamId () {
                this.$normalRequest('competition/loadUnfinishedPlayerApplicationsByTeamId', {
                    team_id: this.currentManagedTeamId
                }, false, false, this, 'unfinishedPlayerApplicationRequesting').then(data => {
                    this.unfinishedPlayerApplications = handlePlayerApplications(data);
                }).catch(_ => {
                });
            }
        }
    };
</script>
